import { useQuery } from '@tanstack/react-query';
import type { DashboardColors, DashboardThemeSettings } from '@jema-manager/shared';
import { apiClient } from '@shared/api/api-client';

export const dashboardThemeKey = ['dashboard-branding'] as const;
export const useDashboardTheme = () =>
  useQuery({
    queryKey: dashboardThemeKey,
    queryFn: async () =>
      (
        await apiClient.get<{ data: DashboardThemeSettings }>('/branding', undefined, {
          skipAuth: true,
          skipDoctorControlHeader: true,
          retries: 0,
        })
      ).data,
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
  });
export const loadThemeSettings = async () =>
  (await apiClient.get<{ data: DashboardThemeSettings }>('/super-admin/branding')).data;
export const saveThemeSettings = async (colors: DashboardColors) =>
  (await apiClient.put<{ data: DashboardThemeSettings }>('/super-admin/branding', { colors })).data;
